import React, { useCallback, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { useTranslation } from 'react-i18next';
import { Flex } from 'nallian-shared-ui/lib/components';
import updateThemeLookupService from '../services/updateThemeLookupService';
import themeLookupService from '../services/themeLookupService';
import ThemeLookupForm from './ThemeLookupForm';

const EditThemeLookup = ({
  open,
  dispatchUpdateThemeLookupPut,
  updateThemeLookupFetch,
  dispatchThemeLookupGet,
  themeLookupFetch,
}) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();

  const handleSubmit = useCallback(
    body => dispatchUpdateThemeLookupPut(id, body, () => navigate(`/theme-lookups`), t),
    [id, dispatchUpdateThemeLookupPut, navigate, t]
  );

  useEffect(() => {
    if (open && id) {
      dispatchThemeLookupGet(id, () => navigate('/theme-lookups'), t);
    }
  }, [id, open, t, dispatchThemeLookupGet, navigate]);

  if (!open) return null;

  return (
    <ThemeLookupForm
      header={
        <Flex alignItems="center">
          {t('editThemeLookup')}&nbsp;-&nbsp;{themeLookupFetch.value?.title}
        </Flex>
      }
      onSubmit={handleSubmit}
      submitProcessing={updateThemeLookupFetch.pending}
      returnRoute="/theme-lookups"
      cancelRoute="/theme-lookups"
      dataLoading={themeLookupFetch.pending}
      data={!themeLookupFetch.pending && themeLookupFetch.value}
      cancelButtonContent={t('close')}
      noSaveButton
      showRemoveButton
      editMode
    />
  );
};

EditThemeLookup.propTypes = {
  dispatchUpdateThemeLookupPut: PropTypes.func.isRequired,
  updateThemeLookupFetch: PropTypes.object.isRequired,
  dispatchThemeLookupGet: PropTypes.func.isRequired,
  themeLookupFetch: PropTypes.object.isRequired,
  open: PropTypes.bool,
};

EditThemeLookup.defaultProps = { open: false };

export default compose(themeLookupService, updateThemeLookupService)(EditThemeLookup);
